var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import { BInputGroup, BFormInput, BInputGroupAppend, BButton, BIconSearch, BIconChevronDown } from 'bootstrap-vue';
var SearchInput = /** @class */ (function (_super) {
    __extends(SearchInput, _super);
    function SearchInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.uniqueId = '';
        return _this;
    }
    SearchInput.prototype.created = function () {
        this.uniqueId = this.uuidv4();
    };
    SearchInput.prototype.uuidv4 = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0, v = c == 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    };
    __decorate([
        Prop({ default: 'search' }),
        __metadata("design:type", String)
    ], SearchInput.prototype, "name", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], SearchInput.prototype, "value", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], SearchInput.prototype, "placeholder", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], SearchInput.prototype, "variant", void 0);
    SearchInput = __decorate([
        Component({
            components: {
                BIconChevronDown: BIconChevronDown,
                BInputGroup: BInputGroup,
                BFormInput: BFormInput,
                BInputGroupAppend: BInputGroupAppend,
                BButton: BButton,
                BIconSearch: BIconSearch,
            },
        })
    ], SearchInput);
    return SearchInput;
}(Vue));
export default SearchInput;
